import React from 'react';

import { createRoot } from 'react-dom/client';

import './bootstrap';

import App from '~/App';

import '~/polyfills';
import '~/index.scss';
import { createCustomTheme } from './theme';

import '../config';

// eslint-disable-next-line import/no-named-as-default-member
const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <App createCustomTheme={createCustomTheme} />
  </React.StrictMode>,
);
